
export default function About() {
  return (
    <section id="sobre-nosotros" className="py-12 sm:py-20 lg:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/fec4075f6bf5bb04b7c31942b86e3162.jpg"
                alt="Empresa familiar de desguace en Castelldefels especializada en coches siniestrados"
                className="w-full h-64 sm:h-80 lg:h-full object-cover object-top"
              />
            </div>
            {/* Floating Stats - Hidden on mobile */}
            <div className="hidden sm:block absolute -bottom-4 sm:-bottom-6 -right-2 sm:-right-6 bg-white rounded-xl sm:rounded-2xl shadow-xl p-4 sm:p-6 border border-gray-100">
              <div className="text-center">
                <div className="text-2xl sm:text-4xl font-bold text-teal-600 mb-1">3</div>
                <div className="text-xs sm:text-sm text-gray-600 whitespace-nowrap">Generaciones</div>
              </div>
            </div>
            {/* Second Floating Element - Hidden on mobile */}
            <div className="hidden sm:block absolute -top-2 sm:-top-4 -left-2 sm:-left-4 bg-teal-600 rounded-xl sm:rounded-2xl shadow-xl p-3 sm:p-4 text-white">
              <div className="flex items-center gap-2">
                <i className="ri-heart-line text-xl sm:text-2xl"></i>
                <span className="text-xs sm:text-sm font-semibold whitespace-nowrap">Empresa Familiar</span>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-teal-100 text-teal-700 rounded-full mb-4 sm:mb-6">
              <i className="ri-team-line text-base sm:text-lg"></i>
              <span className="text-xs sm:text-sm font-semibold whitespace-nowrap">SOBRE NOSOTROS</span>
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              Una <strong>Empresa Familiar</strong> de Confianza en Castelldefels
            </h2>

            <p className="text-sm sm:text-base lg:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              Somos <strong>Desguaces Castelldefels</strong>, una empresa familiar con más de 20 años de historia en el sector del automóvil. Lo que empezó como un pequeño taller de nuestro abuelo, hoy es un referente en la <strong>compra de coches siniestrados en Castelldefels</strong> y alrededores.
            </p>

            <p className="text-sm sm:text-base lg:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              Nuestra filosofía es sencilla: <strong>tratarte como nos gustaría que nos trataran a nosotros</strong>. Por eso ofrecemos valoraciones justas, transparencia total y un trato cercano. Aquí no eres un número, eres parte de nuestra comunidad.
            </p>

            {/* Family Values */}
            <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-lg sm:rounded-xl flex-shrink-0">
                  <i className="ri-hand-heart-line text-xl sm:text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Trato Cercano y Personalizado</h3>
                  <p className="text-gray-600 text-xs sm:text-sm lg:text-base">No somos una gran corporación. Somos una familia que entiende tus necesidades. Te atendemos personalmente y resolvemos todas tus dudas sobre la venta de tu coche siniestrado.</p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-lg sm:rounded-xl flex-shrink-0">
                  <i className="ri-shield-star-line text-xl sm:text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Honestidad y Transparencia</h3>
                  <p className="text-gray-600 text-xs sm:text-sm lg:text-base">Nuestro nombre y reputación están en juego. Por eso siempre ofrecemos precios justos sin sorpresas ni letra pequeña. Lo que te decimos es lo que recibes.</p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-lg sm:rounded-xl flex-shrink-0">
                  <i className="ri-map-pin-line text-xl sm:text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Arraigados en Castelldefels</h3>
                  <p className="text-gray-600 text-xs sm:text-sm lg:text-base">Conocemos cada rincón de Castelldefels y el Baix Llobregat. Somos tus vecinos y nos importa nuestra comunidad. Recogemos tu coche siniestrado donde nos digas.</p>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-3 sm:gap-6 mb-6 sm:mb-8">
              <div className="text-center">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-teal-600 mb-1">20+</div>
                <div className="text-xs sm:text-sm text-gray-600">Años de Historia</div>
              </div>
              <div className="text-center">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-teal-600 mb-1">5000+</div>
                <div className="text-xs sm:text-sm text-gray-600">Clientes Satisfechos</div>
              </div>
              <div className="text-center">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-teal-600 mb-1">100%</div>
                <div className="text-xs sm:text-sm text-gray-600">Compromiso</div>
              </div>
            </div>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a
                href="#valoracion"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('valoracion')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-2.5 sm:py-3 bg-teal-600 text-white rounded-full font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
              >
                <i className="ri-calculator-line text-lg sm:text-xl"></i>
                Valoración Gratuita
              </a>
              <a
                href="tel:932932913"
                className="inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-2.5 sm:py-3 bg-gray-900 text-white rounded-full font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
              >
                <i className="ri-phone-line text-lg sm:text-xl"></i>
                932 932 913
              </a>
            </div>
          </div>
        </div>

        {/* Process Section */}
        <div className="mt-12 sm:mt-20 bg-white rounded-2xl sm:rounded-3xl p-5 sm:p-8 lg:p-12 shadow-lg">
          <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-3 sm:mb-4 text-center">
            ¿Cómo Funciona la Venta de tu Coche Siniestrado?
          </h3>
          <p className="text-gray-600 text-center mb-6 sm:mb-10 max-w-2xl mx-auto text-sm sm:text-base">
            Te lo ponemos fácil. En 4 sencillos pasos vendes tu coche siniestrado sin complicaciones.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
            <div className="text-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-3 sm:mb-4">
                <span className="text-lg sm:text-2xl font-bold text-teal-600">1</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Contacta</h4>
              <p className="text-gray-600 text-xs sm:text-sm">Llámanos al 932 932 913 o rellena el formulario.</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-3 sm:mb-4">
                <span className="text-lg sm:text-2xl font-bold text-teal-600">2</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Valoración</h4>
              <p className="text-gray-600 text-xs sm:text-sm">Te damos un precio justo en menos de 1 hora.</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-3 sm:mb-4">
                <span className="text-lg sm:text-2xl font-bold text-teal-600">3</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Recogida</h4>
              <p className="text-gray-600 text-xs sm:text-sm">Recogemos tu coche con grúa sin coste.</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-3 sm:mb-4">
                <span className="text-lg sm:text-2xl font-bold text-teal-600">4</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Pago</h4>
              <p className="text-gray-600 text-xs sm:text-sm">Te pagamos al instante y tramitamos la baja.</p>
            </div>
          </div>
        </div>

        {/* Family Quote */}
        <div className="mt-8 sm:mt-12 bg-teal-600 rounded-2xl sm:rounded-3xl p-5 sm:p-8 lg:p-12 text-white text-center">
          <i className="ri-double-quotes-l text-3xl sm:text-5xl opacity-50 mb-3 sm:mb-4"></i>
          <p className="text-base sm:text-xl lg:text-2xl font-medium mb-4 sm:mb-6 max-w-3xl mx-auto">
            "Nuestro abuelo siempre decía: un cliente satisfecho es el mejor negocio. Esa filosofía sigue viva en cada coche siniestrado que compramos."
          </p>
          <p className="text-teal-200 font-semibold text-sm sm:text-base">— Familia Desguaces Castelldefels</p>
        </div>
      </div>
    </section>
  );
}
